import { useState } from "react";
import { categoryData } from "../../data/mock";
import { type ExecutiveTransaction } from "../../data/executiveOverview";

interface TooltipState { x: number; y: number; item: typeof categoryData[0] | null }

export function CategoryTreemap({ rows }: { rows?: ExecutiveTransaction[] }) {
  const [tooltip, setTooltip] = useState<TooltipState>({ x: 0, y: 0, item: null });
  const [hovered, setHovered] = useState<string | null>(null);

  const categories = rows ? Array.from(rows.reduce((groups, row) => groups.set(row.Category_L2, (groups.get(row.Category_L2) || 0) + row.Spend_Amount_USD), new Map<string, number>()), ([name, amount], index) => ({ name, value: amount / 1_000_000, color: categoryData[index % categoryData.length].color })).sort((first, second) => second.value - first.value).slice(0, 8) : categoryData;
  const total = categories.reduce((s, c) => s + c.value, 0);

  return (
    <div className="chart-panel" style={{ position: "relative" }}>
      <div className="chart-panel__title">Spend by Category</div>
      <div className="chart-panel__sub">Proportional view of category spend (USD millions)</div>

      <div className="treemap" style={{ marginTop: 8, width: '100%', height: '260px', minHeight: 180, maxHeight: 340 }}>
        {categories.map((c, i) => {
          const isHovered = hovered === c.name;
          return (
            <div
              key={c.name}
              className={`treemap__cell treemap__cell--${i + 1}`}
              style={{
                background: c.color,
                opacity: hovered && !isHovered ? 0.7 : 1,
                transform: isHovered ? "scale(1.015)" : "scale(1)",
                transition: "opacity 0.2s, transform 0.18s",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                setHovered(c.name);
                setTooltip({ x: e.clientX, y: e.clientY, item: c });
              }}
              onMouseLeave={() => { setHovered(null); setTooltip({ x: 0, y: 0, item: null }); }}
            >
              <div className="treemap__cell-name">{c.name}</div>
              <div className="treemap__cell-value">${c.value.toFixed(1)}M</div>
              {isHovered && (
                <div style={{ fontSize: 9, color: "rgba(255,255,255,0.7)", marginTop: 2 }}>
                  {((c.value / (total || 1)) * 100).toFixed(1)}% of displayed categories
                </div>
              )}
            </div>
          );
        })}
      </div>

      {tooltip.item && (
        <div style={{
          position: "fixed",
          top: tooltip.y - 60, left: tooltip.x + 12,
          background: "#1a1a2e", color: "#fff",
          borderRadius: 8, padding: "8px 12px",
          fontSize: 11, pointerEvents: "none", zIndex: 500,
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        }}>
          <div style={{ fontWeight: 700, marginBottom: 2 }}>{tooltip.item.name}</div>
          <div>${tooltip.item.value.toFixed(1)}M · {((tooltip.item.value / (total || 1)) * 100).toFixed(1)}%</div>
        </div>
      )}
    </div>
  );
}
